import { Sparkles, TrendingUp, Wrench, ShieldCheck, Palette, Gauge, Plug, Scale, Smartphone, Zap } from "lucide-react";

// Métadonnées visuelles des catégories de nouveautés (Design System PROGÈRE V3).
export const RELEASE_CATEGORIES = {
  new: { icon: Sparkles, color: "var(--pg-gold)", fr: "NOUVEAU", en: "NEW", labelFr: "Nouveautés", labelEn: "What's new" },
  improvement: { icon: TrendingUp, color: "var(--pg-info)", fr: "AMÉLIORÉ", en: "IMPROVED", labelFr: "Améliorations", labelEn: "Improvements" },
  fix: { icon: Wrench, color: "var(--pg-success)", fr: "CORRIGÉ", en: "FIXED", labelFr: "Corrections", labelEn: "Fixes" },
  security: { icon: ShieldCheck, color: "var(--pg-red)", fr: "SÉCURITÉ", en: "SECURITY", labelFr: "Sécurité", labelEn: "Security" },
  design: { icon: Palette, color: "var(--pg-gold)", fr: "DESIGN", en: "DESIGN", labelFr: "Design", labelEn: "Design" },
  performance: { icon: Gauge, color: "var(--pg-info)", fr: "PERFORMANCE", en: "PERFORMANCE", labelFr: "Performance", labelEn: "Performance" },
  integration: { icon: Plug, color: "var(--pg-success)", fr: "INTÉGRATION", en: "INTEGRATION", labelFr: "Intégrations", labelEn: "Integrations" },
  legal: { icon: Scale, color: "var(--pg-text-muted)", fr: "LÉGAL", en: "LEGAL", labelFr: "Légal", labelEn: "Legal" },
  mobile: { icon: Smartphone, color: "var(--pg-info)", fr: "MOBILE", en: "MOBILE", labelFr: "Mobile", labelEn: "Mobile" },
  automation: { icon: Zap, color: "var(--pg-info)", fr: "AUTOMATISATION", en: "AUTOMATION", labelFr: "Automatisation", labelEn: "Automation" },
};

export const CATEGORY_ORDER = ["new", "improvement", "design", "performance", "integration", "automation", "mobile", "fix", "security", "legal"];

export const catMeta = (c) => RELEASE_CATEGORIES[c] || RELEASE_CATEGORIES.new;

// Titre/description selon la langue (repli sur le français si l'anglais manque).
export const pick = (obj, base, lang) => {
  if (lang === "en") return (obj[`${base}_en`] || obj[`${base}_fr`] || "").trim();
  return (obj[`${base}_fr`] || "").trim();
};
